import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalInvestmentRecord {
  id: number;
  ledger_id: number;
  reference_month: string;
  opening_balance: number;
  contributions: number;
  withdrawals: number;
  closing_balance: number;
  data_source_note?: string;
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listInvestmentRecords() {
  return dbGetAll<LocalInvestmentRecord>('investment_records');
}

export async function listRecordsByLedger(ledgerId: number) {
  const all = await listInvestmentRecords();
  return all.filter((record) => record.ledger_id === ledgerId);
}

export function getInvestmentRecordById(id: number) {
  return dbGetById<LocalInvestmentRecord>('investment_records', id);
}

export async function getInvestmentRecordByServerId(serverId: number) {
  const all = await listInvestmentRecords();
  return all.find((record) => record.server_id === serverId);
}

export async function createInvestmentRecord(
  data: Omit<LocalInvestmentRecord, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('investment_records', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateInvestmentRecord(id: number, data: Partial<LocalInvestmentRecord>) {
  const current = await dbGetById<LocalInvestmentRecord>('investment_records', id);
  if (!current) throw new Error('Record not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('investment_records', updated);
  return updated;
}

export function removeInvestmentRecord(id: number) {
  return dbDelete('investment_records', id);
}

export async function markInvestmentRecordSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalInvestmentRecord>('investment_records', id);
  if (!current) throw new Error('Record not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('investment_records', current);
  return current;
}
